module.exports = __webpack_public_path__ + "img/batch.08f13e0b.png";